import { Link } from 'react-router-dom';

type HomePageCardProps = {
  title: string;
  text: string;
  Icon: any;
  href: string;
  linkTitle: string;
};

const HomePageCard = (props: HomePageCardProps) => {
  return (
    <div className="max-w-sm p-6 border rounded-lg shadow-md bg-gray-800 border-gray-700">
      {props.Icon}
      <Link to={props.href}>
        <h5 className="mb-2 text-2xl font-semibold tracking-tight text-white">{props.title}</h5>
      </Link>
      <p className="mb-3 font-normal text-gray-400">{props.text}</p>
      <Link to={props.href} className="inline-flex items-center text-blue-600 hover:underline">
        {props.linkTitle}
        <svg className="w-5 h-5 ml-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"></path>
          <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"></path>
        </svg>
      </Link>
    </div>
  );
};

export default HomePageCard;
